import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AnalyticsFilterProvider }  from "./context/AnalyticsFilterContext";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AnalyticsFilterProvider>
      <App />
    </AnalyticsFilterProvider>
  </React.StrictMode>,
);